<template>
    <div>
        <div class="row">
            <div class="col-md-6">
                <div class="c-field">
                    <label class="c-field__label">Key</label>

                    <input  :disabled="this.state === 'edit'" :readonly="this.readonly" v-model="form.property.key" @keydown="enforceKeyChars($event)" class="c-input" type="text">
                    <span class="text-danger" >
                        {{ this.keyWarn }}
                    </span>
                </div>
            </div>

            <div class="col-md-6">
                <div class="c-field">
                    <label class="c-field__label" >Value</label>
                    <input  :readonly="this.readonly" v-model="form.property.value" @keyup="validateValue" class="c-input" type="text">
                    <span class="text-danger" >
                        {{ this.valueWarn }}
                    </span>
                </div>
            </div>
        </div>
        <div class="form-group row mb-0">
            <div class="col-md-12" align="center" >
                <button type="submit" class="btn btn-secondary "
                        @click.prevent="reset"
                        :disabled="form.busy">
                    Reset
                </button>
                <button type="submit" class="btn btn-secondary " v-if="this.state === 'edit'"
                        @click.prevent="deleteAttribute"
                        :disabled="form.busy">
                    Delete
                </button>
                <button type="submit" class="btn btn-primary" v-if="this.state === 'edit'"
                        @click.prevent="update"
                        :disabled="form.busy">
                    Save
                </button>
                <button type="submit" class="btn btn-primary" v-if="this.state === 'create'"
                        @click.prevent="create"
                        :disabled="form.busy">
                    Create
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { teamCustomAttributesClient } from '../../../services';

export default {
    props: ['user', 'team'],

    /**
     * The component's data.
     */
    data() {
        return {
            keyWarn: '',
            valueWarn: '',
            state: 'create',
            readonly: false,
            form: new SparkForm({
                property: {},
                handle: '',
            }),
        };
    },

    /**
     * Prepare the component.
     */
    mounted() {
        this.form.property = {};
        this.state = 'create';
        this.readonly = false;
    },

    created() {
        Bus.$on('teamCustomAttribute.edit', (attribute) => {
            this.edit(attribute);
        });
        Bus.$on('teamCustomAttribute.deleted', () => {
            this.reset();
        });

        Bus.$on(`sparkFormUpdated.${this.form.sparkFormId}`, this.$forceUpdate)
    },

    methods: {
        /**
         * make sure we only allow certain chars in the keys
         *
         */
        enforceKeyChars(event) {
            let keyStroke = event.key;

            let regex = /^[a-zA-Z\-_0-9]+$/g;
            let found = regex.test(keyStroke);

            if (!found) {
                this.keyWarn = 'You can only use a-z, A-Z, 0-9, dash, and underscore.';
                event.preventDefault();
            } else {
                this.keyWarn = '';
            }
        },

        edit(attr) {
            this.form.property = {
                id: attr.id,
                key: attr.key,
                value: attr.value,
            };

            this.readonly = false;
            this.state = 'edit';
        },

        deleteAttribute() {
            Swal.fire({
                title: 'Are you sure?',
                text: 'Make sure to review your message templates after deleting this!',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'I am aware, delete the attribute!',
            }).then(({ value }) => {
                if (!value) return;

                teamCustomAttributesClient
                    .deleteCustomAttribute(this.team.id, this.form.property.key)
                    .then(() => {
                        Bus.$emit('teamCustomAttribute.deleted');
                        this.reset();
                    })
                    .catch((error) => {
                        this.state = 'error';
                        console.log(error);
                        this.$toasted.global.platform_error();
                    });
            });
        },

        reset() {
            this.form.property = {};
            this.state = 'create';
            this.readonly = false;
            this.keyWarn = '';
            this.valueWarn = '';
        },
        /**
         * Update the team name.
         */
        update() {
            if (!this.validate()) {
                return;
            }
            teamCustomAttributesClient.updateCustomAttribute(this.team.id, this.form.property.key, { value: this.form.property.value }).then(
                (data) => {
                    this.reset();
                    Bus.$emit('teamCustomAttribute.updated', data.data);
                },
                (error) => {
                    this.state = 'error';
                    console.log(error);
                    this.$toasted.global.platform_error();
                }
            );
        },
        validateValue() {
            let property = this.form.property;
            let valid = true;

            if (
                typeof property.value === 'undefined' ||
                property.value === null ||
                property.value === '' ||
                property.value.length < 1
            ) {
                this.valueWarn = 'Please provide data for the value.';
                valid = false;
            } else {
                this.valueWarn = '';
            }

            return valid;
        },
        validateKey() {
            let property = this.form.property;
            let valid = true;

            if (
                typeof property.key === 'undefined' ||
                property.key === null ||
                property.key === '' ||
                property.key.length < 1
            ) {
                this.keyWarn = 'Please provide a key.';
                valid = false;
            } else {
                this.keyWarn = '';
            }
            return valid;
        },
        validate() {
            let valid = this.validateKey();
            valid &= this.validateValue();
            return valid;
        },
        create() {
            if (!this.validate()) {
                return;
            }
            teamCustomAttributesClient.createCustomAttribute(this.team.id, this.form.property).then(
                (data) => {
                    this.form.property = {};
                    Bus.$emit('teamCustomAttribute.created', data.data);
                    this.reset();
                },
                (error) => {
                    this.state = 'error';
                    let errors = error.response.data.errors;
                    let errorMessage = JSON.stringify(errors);

                    this.$toasted.error(errorMessage);
                }
            );
        },
    },
};
</script>
